import { render, staticRenderFns } from "./PconPrcsIn.vue?vue&type=template&id=f0d86972&scoped=true&"
import script from "./PconPrcsIn.vue?vue&type=script&lang=js&"
export * from "./PconPrcsIn.vue?vue&type=script&lang=js&"
import style0 from "./PconPrcsIn.vue?vue&type=style&index=0&id=f0d86972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d86972",
  null
  
)

export default component.exports